module.exports = ".page-about .hero .hero-inner {\n    padding: 40px 0;\n}\n.logininfos {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n}"